var _g, _path, _g2, _circle, _circle2, _g3, _circle3, _circle4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 81,
    viewBox: "0 0 198 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5781_3340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 61.8439L28.0229 74.6129C28.8684 75.152 29.9825 74.9817 30.6283 74.2146L45.9951 55.9609C46.5858 55.2593 47.578 55.0493 48.4023 55.4516L59.7286 60.9793C60.7111 61.4588 61.8965 61.0606 62.3902 60.0852L75.083 35.0098C75.7435 33.705 77.5354 33.5271 78.4395 34.6768L90.8786 50.4941C91.6947 51.5317 93.2744 51.5081 94.0591 50.4466L99.8894 42.5588C100.515 41.7129 101.688 41.4959 102.574 42.0622L117.252 51.4389C118.207 52.049 119.477 51.7445 120.052 50.7678L136.769 22.3604C137.407 21.2762 138.876 21.0433 139.818 21.8767L148.389 29.4582C149.421 30.371 151.045 29.9916 151.565 28.7161L156.382 16.9171C156.742 16.0364 157.672 15.5308 158.606 15.708L170.314 17.9272C170.758 18.0114 171.218 17.9425 171.618 17.7318L192 7",
    stroke: "#297434",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 61.8439L28.0229 74.6129C28.8684 75.152 29.9825 74.9817 30.6283 74.2146L45.9951 55.9609C46.5858 55.2593 47.578 55.0493 48.4023 55.4516L59.7286 60.9793C60.7111 61.4588 61.8965 61.0606 62.3902 60.0852L75.083 35.0098C75.7435 33.705 77.5354 33.5271 78.4395 34.6768L90.8786 50.4941C91.6947 51.5317 93.2744 51.5081 94.0591 50.4466L99.8894 42.5588C100.515 41.7129 101.688 41.4959 102.574 42.0622L117.252 51.4389C118.207 52.049 119.477 51.7445 120.052 50.7678L136.769 22.3604C137.407 21.2762 138.876 21.0433 139.818 21.8767L148.389 29.4582C149.421 30.371 151.045 29.9916 151.565 28.7161L156.382 16.9171C156.742 16.0364 157.672 15.5308 158.606 15.708L170.314 17.9272C170.758 18.0114 171.218 17.9425 171.618 17.7318L192 7",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 62.2L27.0165 75.0478C27.8643 75.592 28.9846 75.4206 29.631 74.6478L44.9929 56.2814C45.5841 55.5746 46.5818 55.3632 47.4088 55.7695L58.7217 61.3265C59.7065 61.8102 60.8972 61.4102 61.3902 60.4299L74.0813 35.1951C74.7407 33.884 76.5405 33.7059 77.4441 34.8623L89.8746 50.7714C90.6906 51.8157 92.2782 51.792 93.0626 50.7239L98.8874 42.7925C99.5127 41.941 100.692 41.7227 101.581 42.2941L116.245 51.7231C117.202 52.3385 118.479 52.0326 119.053 51.0503L135.767 22.463C136.405 21.3728 137.881 21.1389 138.824 21.9787L147.382 29.5985C148.415 30.5177 150.046 30.1374 150.566 28.8565L155.383 16.9784C155.742 16.0945 156.675 15.5868 157.612 15.7655L169.31 17.9973C169.756 18.0826 170.219 18.013 170.621 17.7999L191 7",
    stroke: "#4EC040",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_5781_3340)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 63,
    r: 4,
    fill: "#4EC040"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 63,
    r: 4,
    fill: "#4EC040"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 63,
    r: 2,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_5781_3340)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 8,
    r: 4,
    fill: "#4EC040"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 8,
    r: 4,
    fill: "#4EC040"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 8,
    r: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5781_3340",
    x: 2.5,
    y: 1.49969,
    width: 195,
    height: 78.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5781_3340"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5781_3340",
    x: 0,
    y: 55,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5781_3340"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5781_3340",
    x: 182,
    y: 0,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_5781_3340"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGUp);
export default __webpack_public_path__ + "static/media/gUp.11fe9812149be5d09534faff6591cb88.svg";
export { ForwardRef as ReactComponent };